import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorCode } from '@ffd/api-client';
import { selectIsRemoteAccessEnabled, selectIsUserSiteOffline } from '@libs/store';
import { ConfigService, ToastService } from '@libs/shared-services';
import { ApiHttpErrorResponse, DISABLE_GLOBAL_ERROR_TOASTS } from '@libs/utils';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiHttpErrorResponseInterceptorService implements HttpInterceptor {
  private readonly toastService = inject(ToastService);
  private readonly store = inject(Store);
  private readonly configService = inject(ConfigService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldUseOfficeOffline = this.configService.config()?.shouldUseOfficeOffline;
    const isSiteOffline = this.store.selectSignal(selectIsUserSiteOffline)() && shouldUseOfficeOffline;
    const isRemoteAccessDisabled = !this.store.selectSignal(selectIsRemoteAccessEnabled)();

    const isSiteRelatedRequest = req.url.includes('sites') || req.url.includes('site-admin');

    return next.handle(req).pipe(
      catchError((error: unknown) => {
        const disableGlobalErrorToasts = req.context.get(DISABLE_GLOBAL_ERROR_TOASTS);
        const showError =
          (!isSiteOffline || (isSiteOffline && !isSiteRelatedRequest)) &&
          (!isRemoteAccessDisabled || (isRemoteAccessDisabled && !isSiteRelatedRequest));

        if (this.isApiHttpErrorResponse(error) && !disableGlobalErrorToasts && showError) {
          this.toastService.error(error.error.message);
        }
        return showError ? throwError(() => error) : EMPTY;
      }),
    );
  }

  private isApiHttpErrorResponse(error: unknown): error is ApiHttpErrorResponse {
    return (
      error instanceof HttpErrorResponse &&
      error.error?.message !== undefined &&
      error.error?.code !== undefined &&
      error.error.code !== ErrorCode.AUTHENTICATION_FAILED
    );
  }
}
